import classNames from 'classnames';
import { Modifier, SelectionState } from 'draft-js';
import { Component } from 'react';

import { IMAGE_BLOCK_CLASSNAME } from 'my-core/editor-utils';
import { capitalize } from 'my-core/my-utils';

import ImageResizer from './ImageResizer';

export default class ImageBlock extends Component {
  updateSize = (width, height) => {
    this.updateEntityData({ width, height });
  };
  updateEntityData = data => {
    const { block, blockProps, contentState } = this.props;
    const entityKey = block.getEntityAt(0);
    const updatedContentState = contentState.mergeEntityData(entityKey, data);
    blockProps.onUpdateContentState(updatedContentState);
  };

  focus = e => {
    const { block, blockProps } = this.props;
    blockProps.onFocus('IMAGE', block.getKey());
    e.stopPropagation(); // otherwise gets captured by ImageResizer clickAway and immediately closes
  };

  blur = e => {
    if (!e?.defaultPrevented) {
      const { blockProps } = this.props;
      blockProps.onBlur();
    }
  };

  handleDelete = () => {
    const { block, blockProps, contentState } = this.props;
    const beforeBlock = contentState.getBlockBefore(block.getKey());
    // const afterBlock = contentState.getBlockAfter(block.getKey());
    const updatedContentState = Modifier.removeRange(
      contentState,
      SelectionState.createEmpty().merge({
        anchorKey: beforeBlock.getKey(),
        anchorOffset: beforeBlock.getLength(),
        focusKey: block.getKey(),
        focusOffset: 1,
      }),
      'backward',
    );
    this.blur();
    blockProps.onUpdateContentState(updatedContentState);
  };

  render() {
    const { block, blockProps, contentState } = this.props;
    const alignment = block.getData().get('alignment');
    const { readOnly } = blockProps;
    const { alt, height, url, width } = contentState.getEntity(block.getEntityAt(0)).getData();
    const active = block.getKey() === blockProps.focusedBlockKey;

    return (
      <div
        className={classNames(IMAGE_BLOCK_CLASSNAME, {
          [`root_align${capitalize(alignment || '')}`]: !!alignment,
        })}
        css={rootCss}
        onMouseDown={readOnly || active ? undefined : this.focus}
      >
        {active ?
          <ImageResizer
            height={height}
            maxWidthParentSelector=".DraftEditor-root"
            onDelete={this.handleDelete}
            onResizeComplete={this.updateSize}
            onUnselectImage={this.blur}
            url={url}
            width={width}
          />
        : <img
            alt={alt}
            className="IB-img"
            height={height}
            onLoad={
              !readOnly && !(width && height) ?
                e => this.updateEntityData({ width: e.target.naturalWidth, height: e.target.naturalHeight })
              : undefined
            }
            src={url}
            style={{ width }}
            width={width}
          />
        }
      </div>
    );
  }
}

const rootCss = ({ palette }) => ({
  // width: 'fit-content',
  // display: 'block'
  display: 'flex',
  alignItems: 'flex-start', // need this to fix image distortion on larger images in safari
  '@media print': { display: 'block' },
  '.IB-img': {
    display: 'block',
    userSelect: 'none',
    maxWidth: '100%',
    height: 'auto',
    ...(palette.mode === 'dark' && { filter: 'invert(100%) hue-rotate(180deg)' }),
    '@media print': { margin: '0 auto' },
  },
  '&.root_alignCenter': {
    justifyContent: 'center',
  },
  '&.root_alignRight': {
    justifyContent: 'flex-end',
  },
});
